import { RootState } from 'surface/xstore/types'
import { Module } from 'vuex'

export interface AttachmentState {
  fileUploadingToPickerBox: File | null
  linkDisplayAttributes: { [url: string]: any }
}

const defaultState = (): AttachmentState => ({
  fileUploadingToPickerBox: null,
  linkDisplayAttributes: {},
})

const attachmentModule: Module<AttachmentState, RootState> = {
  namespaced: true,
  state: defaultState,
  getters: {
    fileUploadingToPickerBox: (state): any => state.fileUploadingToPickerBox,
    linkDisplayAttributesForUrl: (state): any => (url): any => state.linkDisplayAttributes[url],
  },
  mutations: {
    UPLOAD_FILE(state, file): void {
      state.fileUploadingToPickerBox = file
    },
    COMPLETE_UPLOAD_FILE(state): void {
      state.fileUploadingToPickerBox = null
    },
    CANCEL_UPLOAD_FILE(state): void {
      state.fileUploadingToPickerBox = null
    },
    UPDATE_LINK_DISPLAY_ATTRIBUTES(state, { url, attributes }): void {
      state.linkDisplayAttributes = {
        ...state.linkDisplayAttributes,
        [url]: attributes,
      }
    },
  },
  actions: {
    uploadFileToPickerBox({ commit }, { file }): void {
      commit('UPLOAD_FILE', file)
    },
    completeUploadingFileToPickerBox({ commit }): void {
      commit('COMPLETE_UPLOAD_FILE')
    },
    cancelUploadFileToPickerBox({ commit }): void {
      commit('CANCEL_UPLOAD_FILE')
    },
    updateLinkDisplayAttributes({ commit }, payload): void {
      commit('UPDATE_LINK_DISPLAY_ATTRIBUTES', payload)
    },
  },
}

export default attachmentModule
